import { DeleteIcon, RecoverIcon } from '../../icons';
import { FundRowStyle } from './style';
import classNames from 'classnames';

export function FundRow({
  item,
  index,
  isDeleted,
  showDelete = true,
  handleDelete,
  handleRecover
}) {
  const name = item.name || item.current_fund?.name;

  return (
    <FundRowStyle className="row">
      <div className={classNames('item')}>{index}</div>
      <div
        className={classNames('item', {
          'no-mapped': !item.previous_fund
        })}
      >
        {item.previous_fund
          ? item.previous_fund?.name
          : 'This fund was not submitted in the previous period'}
      </div>
      <div
        className={classNames('item', {
          'no-mapped': isDeleted || !name
        })}
      >
        <p>
          {isDeleted
            ? 'You removed this fund from the list'
            : (name ?? 'Fund has been liquidated or merged during the previous reporting period')}
        </p>

        {showDelete && name ? (
          !isDeleted ? (
            <button onClick={() => handleDelete(item.id || item.current_fund?.id, index)}>
              <DeleteIcon />
            </button>
          ) : (
            <button onClick={() => handleRecover(item.id || item.current_fund?.id, index)}>
              <RecoverIcon />
            </button>
          )
        ) : (
          <></>
        )}
      </div>
    </FundRowStyle>
  );
}
